import { VTooltip as i } from "v-tooltip";
/* empty css             */
i.options.defaultClass = "pendo-tooltip";
i.options.defaultBoundariesElement = "viewport";
i.options.defaultHtml = !1;
function f({ classes: t, multiline: p, arrow: o, theme: e }) {
  const s = ["pendo-tooltip"];
  return typeof t == "string" && s.push(...t.split(" ")), Array.isArray(t) && s.push(...t), p && s.push("is-multi-line"), o && s.push("has-tooltip-arrow"), e && s.push(`pendo-tooltip--${e}`), [...new Set(s)];
}
const n = /* @__PURE__ */ function(t) {
  return function(p, { value: o }) {
    return typeof o != "object" ? t(...arguments) : (o.offset == null && (o.offset = 8), o.classes = f(o).join(" "), o.disposeTimeout ? i.options.disposeTimeout = o.disposeTimeout : i.options.disposeTimeout = 2e3, t(...arguments));
  };
}(i.bind), d = {
  ...i,
  bind: n,
  update: n
};
export {
  d as PendoTooltip,
  f as buildClassList,
  d as default
};
//# sourceMappingURL=pendo-tooltip.js.map
